export const APP_INITED = 'APP_INITED';
export const APP_SET_CONFIG = 'APP_SET_CONFIG';
export const APP_SET_CHECKSUM = 'APP_SET_CHECKSUM';
export const APP_UPDATE_ENUMS = 'APP_UPDATE_ENUMS';
